import React from 'react';
import Box from '@mui/material/Box';
import styles from '../Slider/Slider.module.css';

const Dots = ({ activeIndex, imageSlider, handleClickOnDot }) => {
  React.useEffect(() => {}, []);
  return (
    <Box className={styles.alldots} data-testid="todo-2">
      {imageSlider.map((slide, index) => (
        <Box
          onClick={e => handleClickOnDot(index)}
          component="span"
          key={index}
          className={`${
            activeIndex === index
              ? `${styles.dot} ${styles.activedot}`
              : `${styles.dot}`
          }`}></Box>
      ))}
    </Box>
  );
};

export default Dots;
